<div *transloco="let t; read: 'predictive-crosstab'" class="predictive-crosstab__container">
  <div class="predictive-crosstab__table-wrapper">
    <table
      #table
      mat-table
      [dataSource]="dataSource"
      matSort
      [matSortActive]="sort.active"
      [matSortDirection]="sort.direction"
      matSortDisableClear
      (matSortChange)="onSortChanged($event)"
      class="predictive-crosstab__table"
    >
      <ng-container [matColumnDef]="CONSTANTS.BASE_GROUP_COLUMN" sticky>
        <th mat-header-cell *matHeaderCellDef colspan="3"></th>
      </ng-container>

      <ng-container [matColumnDef]="CONSTANTS.BREAKDOWN_COLUMN" sticky>
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ t('breakdown') }}</th>
        <td mat-cell *matCellDef="let breakdown" class="predictive-crosstab__border-left">
          {{ breakdown.name }}
        </td>
      </ng-container>

      <ng-container [matColumnDef]="CONSTANTS.DEPENDENT_COLUMN" sticky>
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ dependentColumnLabel }}</th>
        <td mat-cell *matCellDef="let breakdown">
          {{ breakdown.value | number: numberPipeDigitInfo }}
        </td>
      </ng-container>

      <ng-container [matColumnDef]="CONSTANTS.PERCENTAGE_COLUMN" sticky>
        <th
          mat-header-cell
          mat-sort-header
          *matHeaderCellDef
          class="predictive-crosstab__border-right"
        >
          {{ t('percentage') }}
        </th>
        <td mat-cell *matCellDef="let breakdown" class="predictive-crosstab__border-right">
          {{ breakdown.weight | percent }}
        </td>
      </ng-container>

      @for (driverColumnGroupDef of driverColumnGroupDefs; track driverColumnGroupDef) {
        <ng-container matColumnDef="{{ driverColumnGroupDef.name }}">
          <th
            mat-header-cell
            *matHeaderCellDef
            [colSpan]="colSpan"
            class="predictive-crosstab__driver-column-header"
          >
            {{ driverColumnGroupDef.label }}
          </th>
        </ng-container>
        <ng-container
          [matColumnDef]="formatColumnDefName(CONSTANTS.CURRENT_COLUMN, driverColumnGroupDef.name)"
        >
          <th
            mat-header-cell
            mat-sort-header
            *matHeaderCellDef
            [ngClass]="{
              'predictive-crosstab__border-right': isLastDriverSubColumn(CONSTANTS.CURRENT_COLUMN),
            }"
          >
            {{ changeColumnLabel || t('metric') }}
          </th>
          <td
            mat-cell
            *matCellDef="let breakdown"
            [ngClass]="{
              'predictive-crosstab__border-right': isLastDriverSubColumn(CONSTANTS.CURRENT_COLUMN),
            }"
          >
            {{
              getDriver(breakdown, driverColumnGroupDef.name).current | number: numberPipeDigitInfo
            }}
          </td>
        </ng-container>
        <ng-container
          [matColumnDef]="formatColumnDefName(CONSTANTS.CHANGE_COLUMN, driverColumnGroupDef.name)"
        >
          <th
            mat-header-cell
            mat-sort-header
            *matHeaderCellDef
            [ngClass]="{
              'predictive-crosstab__border-right': isLastDriverSubColumn(CONSTANTS.CHANGE_COLUMN),
            }"
          >
            {{ t('change') }}
          </th>
          <td
            mat-cell
            *matCellDef="let breakdown"
            [ngClass]="{
              'predictive-crosstab__border-right': isLastDriverSubColumn(CONSTANTS.CHANGE_COLUMN),
            }"
          >
            <app-lex-change-indicator
              [old]="getDriver(breakdown, driverColumnGroupDef.name).trend"
              [new]="getDriver(breakdown, driverColumnGroupDef.name).current"
              [decimal]="+predictiveOptions.decimals"
            ></app-lex-change-indicator>
          </td>
        </ng-container>
        <ng-container
          [matColumnDef]="formatColumnDefName(CONSTANTS.SCORE_COLUMN, driverColumnGroupDef.name)"
        >
          <th
            mat-header-cell
            mat-sort-header
            *matHeaderCellDef
            [ngClass]="{
              'predictive-crosstab__border-right': isLastDriverSubColumn(CONSTANTS.SCORE_COLUMN),
            }"
          >
            {{ t('importance') }}
          </th>
          <td
            mat-cell
            *matCellDef="let breakdown"
            [ngClass]="{
              'predictive-crosstab__border-right': isLastDriverSubColumn(CONSTANTS.SCORE_COLUMN),
            }"
          >
            {{
              getDriver(breakdown, driverColumnGroupDef.name).importancePopulator
                | number: numberPipeDigitInfo
            }}
          </td>
        </ng-container>
        <ng-container
          [matColumnDef]="formatColumnDefName(CONSTANTS.RANK_COLUMN, driverColumnGroupDef.name)"
        >
          <th
            mat-header-cell
            mat-sort-header
            *matHeaderCellDef
            [ngClass]="{
              'predictive-crosstab__border-right': isLastDriverSubColumn(CONSTANTS.RANK_COLUMN),
            }"
          >
            {{ t('rank') }}
          </th>
          <td
            mat-cell
            *matCellDef="let breakdown"
            [ngClass]="{
              'predictive-crosstab__border-right': isLastDriverSubColumn(CONSTANTS.RANK_COLUMN),
            }"
          >
            {{ getDriver(breakdown, driverColumnGroupDef.name).importanceCounter }}
          </td>
        </ng-container>
      }

      <tr
        mat-header-row
        *matHeaderRowDef="groupColumns; sticky: true"
        class="predictive-crosstab__driver-header-row"
      ></tr>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: true"
        class="predictive-crosstab__header-row"
      ></tr>

      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="predictive-crosstab__row"
      ></tr>
    </table>
  </div>

  <div class="predictive-crosstab__settings">
    <xi-checkbox
      color="CX"
      [label]="t('metric')"
      [checked]="isCurrentScoreChecked"
      (onChange)="isCurrentScoreChecked = $event.detail.target.checked; refresh()"
    ></xi-checkbox>

    <xi-checkbox
      color="CX"
      [label]="t('change')"
      [disabled]="!showChange"
      [checked]="isChangeChecked"
      (onChange)="isChangeChecked = $event.detail.target.checked; refresh()"
    ></xi-checkbox>

    <div class="predictive-crosstab__importance">
      <xi-checkbox
        color="CX"
        [label]="t('importance')"
        [checked]="isImportanceChecked"
        (onChange)="isImportanceChecked = $event.detail.target.checked; refresh()"
      ></xi-checkbox>

      <xi-toggle-switch
        [leftText]="t('score')"
        [rightText]="t('rank')"
        type="button"
        color="CX"
        [disabled]="!isImportanceChecked"
        [isToggled]="false"
        (onToggle)="isImportanceToggled = $event.detail.isToggled; refresh()"
      ></xi-toggle-switch>
    </div>
  </div>
</div>
